import React, { Fragment } from 'react';

import MaterialTable from 'material-table';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import PickupOrderListItem from '../../../models/PickupOrderListItem';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import { AttachFile, CameraAlt as Camera } from '@material-ui/icons';
import { Tooltip, Paper, Badge } from '@material-ui/core';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      border: '1px solid rgba(9, 43, 74, 1)',
      paddingTop: '25px',
      boxShadow: '2px 2px 5px rgb(0 0 0 / 35%)',
      borderRadius: '15px',
      position: 'relative',
      marginBottom: '30px',
      paddingBottom: '25px',
      backgroundColor: 'white',
    },
    PoD: {
      color: 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-between'
    },
    green: {
      backgroundColor: 'green !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    red: {
      backgroundColor: 'red !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    materialIcon: {
      padding: '0px 6px 0px',
      fontSize: '20px',
    },
    specials: {
      display: 'flex',
      flexDirection: 'column',
    },
    gap4px: {
      gap: '4px',
    },
    flexSpcl: {
      flexWrap: 'nowrap'
    },
    ordersPaper: {
      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }
    },
    '@media (max-width: 991px)': {
      flexSpcl: {
        flexWrap: 'wrap'
      },
    }
  });

interface WhsDoDetailsTableProps {
  classes: any;
  dropOffOrder: OrderWhsDetails;
  selectedAwb: string;
  handleChangeAwb: (awbNumber: string, version: number) => void;
  handleOpenPoD: (awbCode: string, awbNumber: string, version: number) => void;
  openDialog: (type: string, awbCode: string, awbNumber: string, version: number) => void;
  history: any;
  uploadFile: (event: any, awbCode: string, awbNumber: string, version: number) => void;
};


const whsDoDetailsTable = (props: WhsDoDetailsTableProps) => {

  const { dropOffOrder } = props;
  const disabled: boolean = dropOffOrder.status === 'delivered' || dropOffOrder.lock_status !== OrderLockStatusType.LOCKED;

  return (
    <div className={`${ props.classes.ordersPaper } ${ commonStyles.paperTable } ${ commonStyles.SelectTable }`} >

      <MaterialTable
      
        onRowClick={ (event: any, rowData: any) => props.handleChangeAwb(rowData.code + '-' + rowData.number, rowData.version) }

        data={ dropOffOrder.list } 

        columns={[
          { title: 'SPL', field: 'awb', cellStyle: { padding: 0, margin: 0, width: '20%' }, headerStyle: { padding: '10px 0 10px 0', width: '20%', height: '1%' },
          render: (rowData: PickupOrderListItem) => { 
  
            return<span className={`${ commonStyles.dFlex } ${ props.classes.flexSpcl } ${ props.classes.gap4px }`}>
              { rowData.special_form_data ? rowData.special_form_data.specials_form_data.map((special: any) => {
                if (special.value) {
                  return (
                    <span className={ props.classes.specials }>
                      <div style={{ backgroundColor: special.color, border: special.border ? `dashed 2px ${special.border}` : ''    }} className={`${ commonStyles.specials }`}><div className={ commonStyles.colorPrimary }>{special.name}</div>
                      </div>
                      <span className={ commonStyles.spTemp }>{special.temp ? special.temp : ''}</span>
                    </span>
                  )
                }

              }) : null }
              {  rowData.special_form_data && rowData.special_form_data.other.name.length ? 
              rowData.special_form_data.other.name.map(others =><div style={{ backgroundColor: '#ffffff', border: '1px solid var(--primaryblue)', color: 'var(--primaryblue)' }} className={`${commonStyles.specials}`}>{others}</div>)
             : null }
            </span>;
          }
          },
          { title: 'Awb', field: 'awb', cellStyle: { padding: 0, margin: 0 }, headerStyle: { padding: '10px 0 10px 0', height: '1%' },
            render: (rowData: PickupOrderListItem) => { 

            return <span> <span className={ commonStyles.spaceNowrap }>{ rowData.code }-{ rowData.number }</span> {rowData.returned? <span style={{color: 'red'}}>Returned to driver</span>: null}</span>;
            }
          },
          { title: '', cellStyle: { width: '8%' }, headerStyle: { width: '8%' },
            render: (rowData: PickupOrderListItem) => {
              if (rowData.status === 'SHIPMENT DELIVERED' || rowData.status === 'SHIPMENT PARTIALLY DELIVERED' ||
                  rowData.status === 'SHIPMENT REJECTED' || rowData.status === 'SHIPMENT PARTIALLY REJECTED') {
                return (
                  <span>
                    <span className={ props.classes.PoD } onClick={ () => props.handleOpenPoD(rowData.code , rowData.number, rowData.version) }>PoD</span>
                  </span>
                )
              } return null
          }},
        { title: 'Pcs', field: 'pieces', cellStyle: { padding: 0, margin: 0, width: '10%' }, headerStyle: { padding: '10px 0 10px 0', width: '10%', height: '1%' } },
        { title: 'Dst', field: 'dst', cellStyle: { padding: 0, margin: 0, width: '10%' }, headerStyle: { padding: '10px 0 10px 0', width: '10%', height: '1%' } },
        { title: 'Notes', field: 'info_to_wh', render: (rowData: PickupOrderListItem) => {
          let remark = (rowData.info_to_wh)? rowData.info_to_wh : rowData.remarks_text
          return remark
        }, cellStyle: { padding: 0, margin: 0, width: '30%' }, headerStyle: { padding: '10px 0 10px 0', width: '35%', height: '1%' }},
        { title: 'Action',
          render: (rowData: PickupOrderListItem) => {
            const iconColor = (rowData.screened) ? props.classes.green : props.classes.red;
             return <span className={ props.classes.awbActionsList }>
                { !dropOffOrder.rfs_number && 
                <Tooltip title="Screen AWB">
                  <div><p className={ iconColor } onClick={ (events) => props.history.push(`/screening/${rowData.code}/${rowData.number}/${rowData.version}/${props.dropOffOrder.number}`) }>SCR</p></div>
                </Tooltip> 
                }
                <Tooltip title="View Attachments">
                  <span>
                    <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachmentCount }>
                      <AttachFile className={ props.classes.materialIcon } onClick={ (events) => props.openDialog('attachments', rowData.code, rowData.number, rowData.version) }/>
                    </Badge>
                  </span>
                </Tooltip>
                <Tooltip title="Attach file">
                  <Fragment>
                    <Camera className={ props.classes.camera } onClick={ (event) => props.uploadFile(event, rowData.code, rowData.number, rowData.version) }/>
                    <input id="fileUpload" hidden type="file"  name="attachment" onChange={ (event) => props.uploadFile(event, rowData.code, rowData.number, rowData.version) }/>
                  </Fragment>
                </Tooltip>
               </span>
          }
        }
      ]}

        options={{
          maxBodyHeight: 205,
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
            },
          rowStyle: ( rowData: PickupOrderListItem ) => ({
            color: ( props.selectedAwb === ( rowData.code + '-' + rowData.number )) ? '#fff' : '#000',
          }),
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
};

export default withStyles(styles)(whsDoDetailsTable);